/* ============================================================================
   Curated Collection JS — Horizon Path A (DOM-reorder, no grid wipe)
   v2026-05-12
============================================================================ */

(() => {
  const GRID_SEL = 'ul.product-grid';
  const ITEM_CLASS = 'product-grid__item';

  const qp = new URLSearchParams(location.search);

  let rawFirst = decodeURIComponent((qp.get('first') || '').trim());
  let firstHandle = '';
  let variantFromURL = '';

  if (rawFirst.startsWith('http')) {
    try {
      const u = new URL(rawFirst);
      const segs = u.pathname.split('/').filter(Boolean);
      if (segs[0] === 'products' && segs[1]) firstHandle = segs[1];
      variantFromURL = u.searchParams.get('variant') || '';
    } catch (_) {}
  } else {
    const segs = rawFirst.split('/').filter(Boolean);
    firstHandle = segs.pop();
  }
  if (!firstHandle) return;

  // Orange Loaf: intentionally ignore the variant. The pinned card shows the
  // product default color + "From $29.99" (matches the rest of the grid, handled
  // server-side in snippets/price.liquid) and skips the slow client-side image
  // swap that caused the lag. Per WeScale pinning thread (Mary Hamilton).
  const variantID = '';

  const grid = document.querySelector(GRID_SEL);
  if (!grid) return;

  const previewExtras = (() => {
    const list = [];
    ['preview_theme_id', 'preview_theme_token', 'pb'].forEach(k => {
      if (qp.has(k)) list.push(`${k}=${encodeURIComponent(qp.get(k) || '')}`);
    });
    return list.join('&');
  })();
  const appendPreview = url =>
    previewExtras ? (url.includes('?') ? `${url}&${previewExtras}` : `${url}?${previewExtras}`) : url;
  const needsCookie = Boolean(previewExtras);

  // Find the product's card already on the page by its handle — synchronous, no
  // /products/<handle>.js round-trip. (variantID is always '' so the product JSON
  // was never needed.) On-page = 0 fetches; off-page = 1 fetch (the card below).
  const findExistingCard = () => {
    let card = null;
    grid.querySelectorAll(`li.${ITEM_CLASS} a[href*="/products/${firstHandle}"]`).forEach(a => {
      if (card) return;
      try {
        const segs = new URL(a.href, location.origin).pathname.split('/').filter(Boolean);
        if (segs[0] === 'products' && segs[1] === firstHandle) card = a.closest(`li.${ITEM_CLASS}`);
      } catch (_) {}
    });
    return { card };
  };

  const fetchCard = async () => {
    const url = appendPreview(
      `/products/${encodeURIComponent(firstHandle)}?view=card${variantID ? `&variant=${variantID}` : ''}`
    );
    const r = await fetch(url, {
      credentials: needsCookie ? 'same-origin' : 'omit',
      cache: 'no-cache'
    });
    if (!r.ok) return '';
    return await r.text();
  };

  const applyVariant = (cardEl, product) => {
    if (!variantID || !product) return;
    const varObj = product.variants.find(v => String(v.id) === variantID);
    if (!varObj || !varObj.featured_image) return;

    const newSrcBase = varObj.featured_image.src;
    cardEl.querySelectorAll('img').forEach(img => {
      const m = img.src.match(/_(\d+x)\./);
      const sized = m ? newSrcBase.replace(/\.(jpg|png|jpeg|webp)/i, `_${m[1]}.$1`) : newSrcBase;
      img.src = sized;
      img.srcset = '';
    });
    cardEl.querySelectorAll('a[href*="/products/"]').forEach(a => {
      try {
        const u = new URL(a.href, location.origin);
        u.searchParams.set('variant', variantID);
        a.href = u.pathname + u.search;
      } catch (_) {}
    });
  };

  (async () => {
    const { card: existingCard } = findExistingCard();

    if (existingCard) {
      grid.prepend(existingCard);
    } else {
      const beforeCount = grid.querySelectorAll(`li.${ITEM_CLASS}`).length;
      const html = await fetchCard();
      if (!html.trim()) return;
      grid.insertAdjacentHTML('afterbegin', html);
      // Match injected pinned card's vertical gap to a native sibling so it tracks the theme "Vertical gap" (ends manual pin fixes).
      try {
        const _inj = grid.querySelector(`li.${ITEM_CLASS}:first-child .product-card__content`);
        const _nat = [...grid.querySelectorAll(`li.${ITEM_CLASS} .product-card__content`)].find(el => !el.closest('[id^="curated-"]'));
        if (_inj && _nat) {
          const _g = getComputedStyle(_nat).getPropertyValue('--product-card-gap').trim();
          if (_g) _inj.style.setProperty('--product-card-gap', _g);
        }
      } catch (_) {}
      // Keep the page's product count constant so pinning never adds an orphan row.
      const items = grid.querySelectorAll(`li.${ITEM_CLASS}`);
      for (let i = items.length - 1; i >= beforeCount; i--) items[i].remove();
    }
  })().catch(() => {});
})();
